import BaseModel from '@core/model';

import { PhoneNumber } from '@/models';

export class CompanyInfo extends BaseModel {
    static entity = 'companyInfos';

    static fields() {
        return {
            company_number: this.string(null).nullable(),
            company_name: this.string(null).nullable(),
            company_status: this.string(null).nullable(),
            company_status_detail: this.string(null).nullable(),
            //
            accounting_reference_day: this.number(null).nullable(),
            accounting_reference_month: this.number(null).nullable(),
            last_accounts_at: this.string(null).nullable(),
            last_accounts_type: this.string(null).nullable(),
            //
            accounts_next_due: this.string(null).nullable(),
            accounts_overdue: this.boolean(null).nullable(),
            accounts_last_made_up_to: this.string(null).nullable(),
            accounts_next_made_up_to: this.string(null).nullable(),
            //
            annual_return_next_due: this.string(null).nullable(),
            annual_return_overdue: this.boolean(null).nullable(),
            annual_return_last_made_up_to: this.string(null).nullable(),
            annual_return_next_made_up_to: this.string(null).nullable(),
            //
            confirmation_statement_next_due: this.string(null).nullable(),
            confirmation_statement_overdue: this.boolean(null).nullable(),
            confirmation_statement_last_made_up_to: this.string(null).nullable(),
            confirmation_statement_next_made_up_to: this.string(null).nullable(),
            //
            date_of_creation: this.string(null).nullable(),
            date_of_cessation: this.string(null).nullable(),
            //
            liquidated: this.boolean(null).nullable(),
            has_charges: this.boolean(null).nullable(),
            has_insolvency_history: this.boolean(null).nullable(),
            //
            jurisdiction: this.string(null).nullable(),
            previous_names: this.attr(null).nullable(),
            sic_codes: this.attr(null).nullable(),
            type: this.string(null).nullable(),
            // These next few are technically not from CH but we do need them for every company
            website: this.string(null).nullable(),
            email: this.string(null).nullable(),
            phone_number: this.model(PhoneNumber).nullable(),
            linkedin_url: this.string(null).nullable(),
            twitter_user: this.string(null).nullable()
        };
    }
}

export default CompanyInfo;
